export default __webpack_public_path__ + "static/media/Estudiantes_scroll.37c326e8.png";